import { ManagerRole } from './ManagerRole';

class Manager {
  constructor(
    readonly id: number | null,
    readonly firstName: string,
    readonly lastName: string,
    readonly email: string,
    readonly role: ManagerRole,
    readonly picture?: string,
    readonly pendingPasswordReset?: boolean,
    readonly passwordExpirationDate?: string,
    readonly uuid?: string,
  ) {}

  static create({
    id,
    firstName,
    lastName,
    email,
    role,
    picture,
    pendingPasswordReset,
    passwordExpirationDate,
    uuid,
  }: {
    id: number | null;
    firstName: string;
    lastName: string;
    email: string;
    role: ManagerRole;
    picture?: string;
    pendingPasswordReset?: boolean;
    passwordExpirationDate?: string;
    uuid?: string;
  }): Manager {
    return new Manager(
      id,
      firstName,
      lastName,
      email,
      role,
      picture,
      pendingPasswordReset,
      passwordExpirationDate,
      uuid,
    );
  }
}

export { Manager };
